// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from editor-quote.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function EditorQuoteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M2.701 14c.38 0 .659-.085.837-.255.177-.17.328-.343.45-.52l2.408-3.25c.246-.328.445-.725.598-1.19a4.69 4.69 0 0 0 .23-1.475V2.775a.752.752 0 0 0-.23-.539A.713.713 0 0 0 6.47 2H1.947a.713.713 0 0 0-.524.236.752.752 0 0 0-.23.539v4.649c0 .214.077.396.23.548a.726.726 0 0 0 .524.226h.901c.123 0 .23.054.322.161.092.107.101.224.028.35l-2.041 3.817c-.196.365-.208.702-.037 1.011.172.309.447.463.827.463h.754zm7.795 0c.367 0 .64-.085.818-.255.178-.17.328-.343.45-.52l2.409-3.25c.257-.328.46-.725.606-1.19A4.87 4.87 0 0 0 15 7.31V2.775a.752.752 0 0 0-.23-.539.713.713 0 0 0-.524-.236H9.742a.703.703 0 0 0-.533.236.767.767 0 0 0-.22.539v4.649a.74.74 0 0 0 .23.548.726.726 0 0 0 .523.226h.9c.123 0 .228.054.313.161.086.107.092.224.019.35L8.95 12.526c-.208.365-.223.702-.045 1.011.177.309.456.463.836.463h.754z"
        />
      </g>
    </svg>
  );
}
